export const textStatus = {
  not_corrected: ['secondary', 'Não corrigida'], pending: ['warning', 'Na fila'], running: ['info', 'Corrigindo'],
  success: ['success', 'Corrigida'], error: ['danger', 'Falha'], outdated: ['warning', 'Correção desatualizada'], no_text: ['secondary', 'Sem texto'],
};
export const formatScore = value => value == null ? '—' : Number(value).toLocaleString('pt-BR', { maximumFractionDigits: 4 });
export function runStatus(run) {
  if (!run.finished_at && Number(run.progress) === Number(run.total) && run.total > 0) return ['info', 'Gerando planilha'];
  if (String(run.status) === '3') return ['danger', 'Concluída com falhas'];
  return ({ '0': ['warning', 'Na fila'], '1': ['info', 'Em andamento'], '2': ['success', 'Concluída'] })[run.status] || ['secondary', 'Aguardando'];
}
